import React, {useState} from 'react';

import classes from './AllProducts.module.css';
import EachProduct from '../EachProduct/EachProduct';

import 'bootstrap/dist/css/bootstrap.min.css';


import db from "../../data/firebase";
import Spinner from 'react-bootstrap/Spinner';


function AllProducts(props){
    const [perfumes, setPerfumes]= useState();
    
    let perfumeList=[];
    let currentUrl= window.location.search;
    let urlParams = new URLSearchParams(currentUrl);
    const currentPath = urlParams.get('men');

    function checking(){
        let i=0;
        db.collection("perfumes").get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                
                let temp={
                    id: doc.id,
                    data: doc.data(),
                }
                if(window.location.pathname == "/products/men"){
                    if(temp.data.gender!=="female"){
                        perfumeList[i]=temp;
                        


                    }
                }
                else if(window.location.pathname == "/products/women"){
                    if(temp.data.gender!=="male"){
                        perfumeList[i]=temp;
                       

                    }
                }
                else{
                    perfumeList[i]=temp;
                    

                }
                
                i++;
                
            });
            setPerfumes(perfumeList);
    
        });
    }
    return(
        
        <div className={classes.box}>
            
            {perfumes ? null :checking()}
            {perfumes? perfumes.map((item) =>(
                <EachProduct item={item} data={item.data} image={item.data.images[0]} 
                            name={item.data.name} className={classes.eachItem}
                             id={item.id} getProduct={props.getProduct}
                             path={window.location.pathname}/>

            )): <Spinner animation="border" />}

          

            
            
          
         
      
       
         
      </div>
    )
}


export default AllProducts;   